import React from 'react'
import { Stack, TextField } from '@mui/material'
import LabelEditor from './LabelEditor'

interface PipelineInfoStepProps {
  name: string
  description: string
  labels: Record<string, string>
  onNameChange: (name: string) => void
  onDescriptionChange: (description: string) => void
  onLabelsChange: (labels: Record<string, string>) => void
  disabled?: boolean
  // Kept so callers can distinguish create from edit; the retired Data Source
  // tiles were the only thing that read it (T20).
  isNewPipeline?: boolean
}

const PipelineInfoStep: React.FC<PipelineInfoStepProps> = ({
  name,
  description,
  labels,
  onNameChange,
  onDescriptionChange,
  onLabelsChange,
  disabled,
}) => {
  return (
    <Stack spacing={3} data-testid="autocoder-pipeline-info-step">
      <TextField
        label="Pipeline Name"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        required
        fullWidth
        disabled={disabled}
        placeholder="Enter a name for this pipeline"
        inputProps={{ 'data-testid': 'autocoder-pipeline-name' }}
      />

      <TextField
        label="Description"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        multiline
        rows={3}
        fullWidth
        disabled={disabled}
        placeholder="Optional description of what this pipeline does"
        inputProps={{ 'data-testid': 'autocoder-pipeline-description' }}
      />

      <LabelEditor
        labels={labels}
        onChange={onLabelsChange}
        disabled={disabled}
      />
    </Stack>
  )
}

export default PipelineInfoStep
